import {
  BlocksRenderer,
  type BlocksContent,
} from "@strapi/blocks-react-renderer";

interface Props {
  info: BlocksContent;
  properties?: string;
}

const parseProperties = (properties?: string): Record<string, string> => {
  if (!properties) return {};
  return properties.split(",").reduce((acc, prop) => {
    const [key, value] = prop.split(":").map((item) => item.trim());
    if (key && value) acc[key] = value;
    return acc;
  }, {} as Record<string, string>);
};

const ProjectInfo = ({ info, properties }: Props) => {
  const parsedProperties = parseProperties(properties);

  return (
    <div className="flex flex-col md:flex-row mb-[7rem]">
      <div className="flex flex-col md:mr-[4rem]">
        <h5 className="mb-[1.2rem]">Description</h5>
        <BlocksRenderer
          blocks={{
            paragraph: ({ children }) => (
              <p className="mb-[4rem] font-light">{children}</p>
            ),
            image: ({ children, image }) => (
              <img
                className="mb-[4rem] w-full mx-auto rounded-[0.8rem]"
                src={image.url}
                alt={image.name}
              />
            ),
            heading: ({ children, level }) => {
              switch (level) {
                case 1:
                  return <h1 className="mb-[1.2rem]">{children}</h1>;
                case 2:
                  return <h2 className="mb-[1.2rem]">{children}</h2>;
                case 3:
                  return <h3 className="mb-[1.2rem]">{children}</h3>;
                case 4:
                  return <h4 className="mb-[1.2rem]">{children}</h4>;
                case 5:
                  return (
                    <h5 className="text-center mb-[1.2rem]">{children}</h5>
                  );
                case 6:
                  return (
                    <h6 className="text-center mb-[1.2rem]">{children}</h6>
                  );
                default:
                  return <h1 className="mb-[1.2rem]">{children}</h1>;
              }
            },
          }}
          content={info}
        />
      </div>

      <div className="flex flex-col bg-gray-200 p-[2.4rem] rounded-[0.5rem] max-w-[41rem] w-full">
        <h5 className="mb-[2.4rem] whitespace-nowrap">Project Details</h5>
        <div className="flex flex-col gap-[1.2rem]">
          {Object.entries(parsedProperties).map(([key, value]) => (
            <div key={key} className="flex flex-col mb-[1.2rem]">
              <p className="text-[rgba(0, 0, 0, 0.80)] font-semibold whitespace-nowrap">
                {key}
              </p>
              <p className="text-[rgba(0, 0, 0, 0.80)] font-light whitespace-nowrap">
                {value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectInfo;
